var bodyHeader = $(document).find('body header');
$(window).scroll(function () {
    if ($(this).scrollTop() > 10) {
      bodyHeader.removeClass("alternate");
        bodyHeader.addClass("solid");
        bodyHeader.addClass("reduced");
    }
    else if ($(this).scrollTop() < 10) {
        if(bodyHeader.hasClass('front')){
          bodyHeader.addClass("alternate");
        }
        bodyHeader.removeClass("solid");
        bodyHeader.removeClass("reduced");
    }
});
var cloneTimes = 0;
const headerMobile = () => {

  if (cloneTimes == 0) {
    var contactBtn = $('.header .header-grid .header-search-cta .header-cta-sidebar a').clone(true);
    $(contactBtn).detach().appendTo('#mega-menu-header-menu').wrap('<li class="mobile-contact-container"></li>');
    cloneTimes = 1;
  }

  var mobileSearch = $(document).find('.header > .header-search-form .search-form');
  var mobileSearch_copy = mobileSearch.clone(true);
  mobileSearch.find('.header-search-form-close').hide();
  $(document).find('#mega-menu-header-menu .header-search-cta').show();

  var back = '<li class="back-btn-placeholder"><span class="back">Back</span></li>';
  var secondLevelMenu = $('#mega-menu-wrap-header-menu #mega-menu-header-menu > li.mega-menu-item > ul.mega-sub-menu');
  if (secondLevelMenu.find('li').hasClass('back-btn-placeholder') == false ) {
    secondLevelMenu.prepend(back);
  }

  $(document).find(secondLevelMenu).find('.back').bind('click', function() {
    $(this).parent().parent().parent().removeClass('mega-toggle-on');
  });

  $(document).find('.mega-toggle-animated').bind('click', function() {
    var attr = $(this).attr('aria-expanded');
    if(attr == 'false') {
      if ($(document).find('#mega-menu-header-menu li').hasClass('search-placeholder') == false) {
        $(document).find('#mega-menu-header-menu').prepend('<li class="search-placeholder"></li>');
        mobileSearch_copy.appendTo('.search-placeholder');

        $(document).find('.search-placeholder .search-form .search-submit').off("click").click(function () {
          var mobile_search_val = $(this).parent().find('.search-field').val();
          $('.header-search-form .search-field').val(mobile_search_val);
          $('.header-search-form .search-submit').trigger('click');
          return false;
        });

        $(document).find('.search-placeholder .search-form .search-field').keypress(function (e) {
          if (e.keyCode == 13) {
            e.preventDefault();
            $('.header-search-form .search-field').val($(this).val());
            $('.header-search-form .search-submit').trigger('click');
            return false;
          }
        });

      }
    }
    else {
      $(document).find('.search-placeholder').remove();
    }
  });

};

$('#mega-menu-header-menu .mega-menu-item .mega-sub-menu .widget_custom_html').bind('click', function() {
  $(this).toggleClass('active');
});

$('#mega-menu-header-menu .mega-menu-item .current_page_item').closest('.mega-menu-row').parent().parent().children('a').addClass('has-active-childlink');

$(window).on('load resize orientationchange', function () {
  if (window.innerWidth <= 768) {
    headerMobile();
    $(document).find('.header .header-grid .header-search-cta').hide();
    $(document).find('.header-search-form-close').hide();
    $(document).find('.header-search-form').hide();
    $(document).find('#mega-menu-header-menu .header-search-cta').show();
  }
  else {
    $(document).find('.header-search-form-close').show();
    $(document).find('.header .header-grid .header-search-cta').show();
    $(document).find('#mega-menu-wrap-header-menu >.header-search-cta').remove();
    $(document).find('.back-btn-placeholder').remove();

    $(document).find('#mega-menu-header-menu .search-placeholder').each(function () {
      $(this).remove();
    });

  }
});
